<template>
<div class="chapter">
<div class="inner_page">
<div style="display:none;"><a id="GBS.PP13.w.0.1.0"></a></div>
<div class="flow" style="">
<a class="page" id="ORIG-GBS.PP13"></a>
<div class="gtxt_body" id="block.12.0.0.box.570.280.427.50.q.80" style="margin-bottom: 1.5em;">
<a id="ORIG-GBS.PP13.w.0.0.0"></a><p class="gtxt_body gtxt_heading" id="para.12.0.0.box.570.280.427.50.q.80" style="text-align:center;">Acknowledgments</p>
</div>
<div class="gtxt_body" id="block.12.1.0.box.230.390.1108.487.q.60">
<a id="ORIG-GBS.PP13.w.1.0.0"></a><p class="gtxt_body" id="para.12.1.0.box.230.390.1108.487.q.60" style="text-indent:1em;">A special thanks goes to Joe Zorger, Lynn Nored, and Kent Bogle for technical advice on aviation, satellites, uplink stations, and explosives. Thanks to Dr. Virgil Trout and Bill Knight for providing unique ins<a id="GBS.PP14"></a><a id="GBS.PP14.w.0.0.0"></a>ight into ancient Egypt. And thanks to those who have continued to support this series with solid advice and encouragement. They are Margo Funk, Ann Hovda, Diann McKasson, Martha Nored, Dale Knowles, Carolyn Knowles, Judith Turner, and Donna Watson.</p>
</div>
</div><div style="display:none;"><a id="GBS.PA1"></a><a id="GBS.PA1.w.0.0.0"></a></div>
<div style="display:none;"><a id="GBS.PA1.w.0.0.0.1"></a></div><div style="display:none;"><a id="GBS.PA1.w.0.0.0.2"></a></div><div class="flow" style="">
</div>
<div style="display:none;"><a id="GBS.PA1.w.0.0.0.3"></a></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content-0007.vue?0ea5f11c